module.exports = __webpack_public_path__ + "img/phone-incoming-error.4bb12319.svg";